import React from 'react';
import { Link } from 'react-router-dom';
import services from './services.json'
import './ourServices.css';
import FeaturesSection from '../../About-us/FeaturesSection';

const HomeSecondSection = () => {
  return (
    <>
      <div className="services-section">
        <div className="services-section-title">
          <h2>Hizmetlerimiz</h2>
        </div>

        <div className="features-container">
          {services.map((item, index) => (
            <FeaturesSection key={`${item.id}`} item={item} index={index} />
          ))}
        </div>

        <div className="link-aboutus">
          <p>Hizmetlerimizin tamamını görmek için lütfen <Link to="/hizmetlerimiz"><b>tıklayınız.</b></Link></p>
        </div>
      </div>
    </>
  );
};

export default HomeSecondSection;
